var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Gallery',{staticClass:"C-fragment-media--gallery",attrs:{"content":_vm.content,"settings":_vm.settings}})
}
var staticRenderFns = []

export { render, staticRenderFns }